import React from "react";
import { Formik } from "formik";
import { Col, Row, Button, notification } from "antd/lib/index";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { postViaje } from "../../../../redux/actions/viajes";
import GeneralInput from "./GeneralInput";
import EtapasInput from "../etapas/EtapasInput";
import { viajeSchema } from "../../../../utils/schemas/viajeSchema";

class CreateViajeForm extends React.Component {
  openNotificationWithIcon = type => {
    notification[type]({
      message: "Viaje añadido exitosamente"
    });
  };

  render() {
    return (
      <Formik
        initialValues={viajeSchema}
        onSubmit={(values, actions) => {
          this.props.onSubmitViaje(values);
        }}
        render={props => (
          <React.Fragment>
            {this.props.addedViaje && this.openNotificationWithIcon("success")}
            <Row gutter={8}>
              <Col span={12}>
                <GeneralInput {...props} />
              </Col>
              <Col span={12}>
                <EtapasInput {...props} />
              </Col>
            </Row>
            <Row>
              <Button onClick={props.handleSubmit}>Submit</Button>
            </Row>
          </React.Fragment>
        )}
      />
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ onSubmitViaje: postViaje }, dispatch);

export default connect(
  null,
  mapDispatchToProps
)(CreateViajeForm);
